<template>
	<div class="partner-content-item">
		<PictureImg
			v-if="image && image.src"
			class="partner-content-item__image"
			:media="image"
			:alt="fields?.image?.value?.alt"
		/>
		<div v-if="title" class="partner-content-item__header">
			<DefaultIcon
				v-if="logo"
				:logo="logo"
				class="partner-content-item__logo"
			></DefaultIcon>
			<p class="partner-content-item__title">{{ title }}</p>
		</div>
		<div
			v-if="richText"
			v-html="richText"
			class="partner-content-item__richtext"
		/>
		<DefaultButton
			v-if="ctaLink?.url || ctaModal"
			:cta-link="ctaLink"
			:icon="ctaIcon"
			:color="buttonColor"
			:gtm="ctaGtm"
			:disabled="ctaDisabled"
			:aria-label="ctaAriaLabel"
			:modal="ctaModal"
		/>
	</div>
</template>

<script setup>
const props = defineProps({
	fields: { type: Object, required: true },
	rendering: { type: Object, required: false },
});

const image = computed(() => props.fields?.image?.value);
const logo = computed(() =>
	props.fields?.logo?.value?.src ? props.fields.logo.value : null
);
const title = computed(() => props.fields?.title?.value);
const richText = computed(() => props.fields?.richText?.value);
const ctaLink = computed(() => props.fields?.ctaLink?.value);
const ctaIcon = computed(() => props.fields?.ctaIcon?.value);
const ctaColor = computed(() => props.fields?.ctaColor?.value);
const ctaGtm = computed(() => props.fields?.ctaGtm?.value);
const ctaDisabled = computed(() => props.fields?.ctaDisabled?.value);
const ctaAriaLabel = computed(() => props.fields?.ctaAriaLabel?.value);
const ctaModal = computed(() => props.fields?.ctaModal);

const buttonColor = ctaColor.value !== "" ? ctaColor.value : "ghost-light";
</script>

<style lang="scss">
.partner-content-item {
	margin-top: var(--spacing-5, 40px);
	width: 100%;

	&:not(:has(.partner-content-item__image)) .partner-content-item__header {
		margin-top: 0;
	}

	.partner-content-item__logo,
	.partner-content-item__logo img {
		width: 64px;
		height: 64px;
		aspect-ratio: 1/1;
		border-radius: 64px;
	}

	.partner-content-item__image img {
		border-radius: 15px;
		padding: 0;
	}

	.partner-content-item__header {
		display: flex;
		align-items: center;
		height: 64px;
		margin-top: var(--spacing-3, 24px);
	}

	.partner-content-item__title {
		color: var(--color-white, #fff);
		font-family: var(--primary-font, sans-serif);
		font-size: 22px;
		font-style: normal;
		font-weight: 300;
		line-height: 120%;
		margin-left: var(--spacing-2, 16px);
	}

	.partner-content-item__header:not(:has(.partner-content-item__logo))
		.partner-content-item__title {
		margin-left: 0;
	}

	.partner-content-item__richtext {
		margin: var(--spacing-3, 24px) 0;
	}

	.cta-btn {
		width: 100%;
	}
}

.partner-content-item:not(:has(.cta-btn)) {
	.partner-content-item__richtext {
		margin-bottom: 0;
	}

	.partner-content-item__richtext p:last-child {
		margin-bottom: 0;
	}
}
</style>
